module.exports = __webpack_public_path__ + "img/make-impact.160cba5a.svg";